import { BiVizSpec, BiVizType } from '@euler/model/bi/viz';

/** What sets a card's height where heights are client-owned. */
export enum BiCardKind {
  Kpi = 'kpi',
  Chart = 'chart',
  Table = 'table',
}

export function biCardKind(viz: BiVizSpec): BiCardKind {
  if (viz.type === BiVizType.Kpi) return BiCardKind.Kpi;
  if (viz.type === BiVizType.Table) return BiCardKind.Table;
  return BiCardKind.Chart;
}
